module.exports = __webpack_public_path__ + "img/plato-default.75378558.jpg";